import { Pipe, PipeTransform } from '@angular/core';

/**
 * Applies kebab casing to a given string.
 * For example, "Hello World" becomes "hello-world"
*/
@Pipe({ name: 'kebabCase' })
export class KebabCasePipe implements PipeTransform {
    transform(value: string): string {
        return value.toLowerCase().replace(/ /g, '-');
    }
}
